import { useState, useEffect } from 'react';
import { useSelector} from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { debounce } from '../components/Helper';
import Spinner from '../components/Spinner';
import '../landing.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCar, faClock, faPhone, faAngleRight, faLocationDot, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import {message} from 'antd';


function Landing() {
    const currentYear = new Date().getFullYear();
    const user = JSON.parse(localStorage.getItem('user'));
    const navigate = useNavigate();

    const logOut = () => {
        message.success('Successfully Logged you out');
        localStorage.removeItem('user');
        navigate('/');
    };

    const {loading} = useSelector(state => state.alerts );

    // FIXED NAVBAR 
    const [prevScrollPos, setPrevScrollPos] = useState(0);
    const [visible, setVisible] = useState(true);

    const handleScroll = debounce(() => {
        const currentScrollPos = window.pageYOffset;

        setVisible((prevScrollPos > currentScrollPos && prevScrollPos - currentScrollPos > 70) || currentScrollPos < 10);

        setPrevScrollPos(currentScrollPos);
    }, 100);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);

    }, [prevScrollPos, visible, handleScroll]);

    const navbarStyles = {
        // position: 'fixed',
        height: '60px',
        width: '100%',
        backgroundColor: 'white',
        textAlign: 'center',
        transition: 'top 0.6s'
    };

    return (
        <div style={{ ...navbarStyles, top: visible ? '0' : '-60px' }}>


            <div className="container-fluid bg-light p-0">
                <div className="row gx-0 d-none d-lg-flex start">
                    <div className="col-lg-7 px-5 text-start">
                        <div className="d-inline-flex py-3 me-4"
                            style={{height: '40px', alignItems: 'center'}}>
                            <FontAwesomeIcon icon={faLocationDot} size="sm" className='me-2' style={{color: 'orangered'}}/>
                            <small>Kimathi street CBD, Nairobi, Kenya</small>
                        </div>
                        <div className="d-inline-flex py-3" style={{height: '50px', alignItems: 'center'}}>
                            <FontAwesomeIcon icon={faClock} size="sm" className='me-2' style={{color: 'orangered'}}/>
                            <small>Mon - Fri : 08.00 AM - 09.00 PM</small>
                        </div>
                    </div>
                    <div className="col-lg-5 px-5 text-end">
                        <div className="d-inline-flex py-3 me-4" style={{height: '100', alignItems: 'center'}}>
                            <FontAwesomeIcon icon={faPhone} size="4x" className='me-2' style={{color: 'orangered'}}/>
                            <small>+254 700112233</small>
                        </div>
                        <div className="d-inline-flex" style={{height: '100', alignItems: 'center'}}>
                            <a className="btn btn-sm-square bg-white text-primary me-1" href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon="fa-brands fa-facebook" style={{color: 'orangered'}} size="6x" />
                            </a>
                            <a className="btn btn-sm-square bg-white text-primary me-1" href="https://twitter.com/" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon="fa-brands fa-twitter" style={{color: 'orangered'}} size="6x"/>
                            </a>
                            <a className="btn btn-sm-square bg-white text-primary me-1" href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon="fa-brands fa-linkedin" style={{color: 'orangered'}} size="6x" />
                            </a>
                            <a className="btn btn-sm-square bg-white text-primary me-0" href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon="fa-brands fa-instagram" style={{color: 'orangered'}} size="6x"/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <nav className="navbar navbar-expand-lg bg-white navbar-light shadow sticky-top p-0">
                
                <a href="/" className="navbar-brand d-inline-flex px-4 py-3 px-lg-5">
                    <h2 className="m-0" style={{color: 'orangered', display: 'inline-flex', justifyContent: 'space-between', alignItems: 'baseline'}}>
                        <FontAwesomeIcon icon={faCar} size="6x" 
                            style={{color: 'orangered', marginRight: '10px'}}/>
                            SmartCars
                    </h2>
                </a>
                
                <button type="button" className="navbar-toggler me-4" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarCollapse">
                    <div className="navbar-nav ms-auto p-4 p-lg-0">
                        <>
                            {
                                localStorage.getItem('user') ?
                                    <>
                                    
                                    </>
                                    :

                                    <>
                                        <a href="/home" className="nav-item nav-link active" style={{color: 'orangered'}}>Home</a>
                                        <a href="/about" className="nav-item nav-link" style={{color: 'orangered'}}>About</a>
                                        <a href="/services" className="nav-item nav-link" style={{color: 'orangered'}}>Services</a>
                                        <a href="/contact" className="nav-item nav-link" style={{color: 'orangered'}}>Contact</a>
                                        <a href="/register" className="nav-item nav-link" style={{color: 'orangered'}}>SignUp</a>
                                        <a href="/login" className="nav-item nav-link" style={{color: 'orangered'}}>Login</a>
                                    </>
                            }
                        </>
                        
                        { localStorage.getItem('user') ?
                            <>
                                <a href="/home" className="nav-item nav-link active" style={{color: 'orangered'}}>Home</a>
                                <a href="/about" className="nav-item nav-link" style={{color: 'orangered'}}>About</a>
                                <a href="/services" className="nav-item nav-link" style={{color: 'orangered'}}>Services</a>
                                <a href="/contact" className="nav-item nav-link" style={{color: 'orangered'}}>Contact</a>
                                
                                <div className="nav-item dropdown">
                                    <a href="/" style={{color: 'orangered'}} className="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                                        <span> {user && user?.name}</span>
                                    </a>
                                    <div className="dropdown-menu fade-up m-0">
                                        <a href="/" className="dropdown-item" style={{color: 'orangered'}} onClick={logOut}>Logout</a>
                                    </div>
                                </div>
                            </>
                            :null
                        }
                    </div>
                </div>
            </nav>

            {loading == true && (<Spinner/>)}

            {/* Carousel Start */}
            <div className="container-fluid p-0 mb-1">
                <div id="header-carousel" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <img className='img-fluid' style={{width: '100%'}} src="https://res.cloudinary.com/self-hosted/image/upload/v1652288592/SmartCars/Fleet/Car-main_ddxbyh.jpg" alt="Image"
                                srcSet="https://res.cloudinary.com/self-hosted/image/upload/v1652288592/SmartCars/Fleet/Car-main_ddxbyh.jpg 300w,
                                    https://res.cloudinary.com/self-hosted/image/upload/v1652288592/SmartCars/Fleet/Car-main_ddxbyh.jpg 600w,
                                    https://res.cloudinary.com/self-hosted/image/upload/v1652288592/SmartCars/Fleet/Car-main_ddxbyh.jpg 1200w"
                                sizes="(min-width: 66em) 33vw,
                                (min-width: 44em) 50vw,
                                100vw"
                            />
                            <div className="carousel-caption d-flex" style={{ alignItems: 'center'}}>
                                <div className="container">
                                    <div className="row justify-content-lg-start"
                                        style={{alignItems: 'center', justifyContent:'center', justifyContentLarge:'start'}}>
                                        <div className="col-10 col-lg-7 text-center text-lg-start">
                                            <h6 className="text-white text-uppercase mb-3 animated slideInDown">Car Hire Services</h6>
                                            <h1 className="display-3 text-white mb-4 pb-3 animated slideInDown">Quality Car Hire Services</h1>
                                            <a href="/" className="btn btn-danger py-3 px-5 animated slideInDown">
                                                More Details <FontAwesomeIcon icon={faAngleRight} size="6x" className='m-1 icon' style={{color: 'white'}}/>
                                            </a>
                                        </div>
                                        <div className="col-lg-5 d-none d-lg-flex animated zoomIn">
                                            <img className="img-fluid" src="https://res.cloudinary.com/self-hosted/image/upload/v1652286534/SmartCars/Landing/carousel-1_sfksns.png" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <img className='img-fluid2' style={{width: '100%'}} src="https://res.cloudinary.com/self-hosted/image/upload/v1652288507/SmartCars/Fleet/car-fleet1_ouez9y.jpg" alt="Image"/>
                            <div className="carousel-caption d-flex align-items-center">
                                <div className="container">
                                    <div className="row justify-content-lg-start"
                                        style={{alignItems: 'center', justifyContent:'center', justifyContentLarge:'start'}}>
                                        <div className="col-10 col-lg-7 text-center text-lg-start">
                                            <h6 className="text-white text-uppercase mb-3 animated slideInDown">Car Rental</h6>
                                            <h1 className="display-3 text-white mb-4 pb-3 animated slideInDown">Best Car Rental Company</h1>
                                            <a href="/" className="btn btn-danger py-3 px-5 animated slideInDown" >
                                                Explore More <FontAwesomeIcon icon={faAngleRight} size="6x" className='m-1' style={{color: 'white'}}/></a>
                                        </div>
                                        <div className="col-lg-5 d-none d-lg-flex animated zoomIn">
                                            <img className="img-fluid" src="https://res.cloudinary.com/self-hosted/image/upload/v1652286534/SmartCars/Landing/carousel-2_bwr0tx.png" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#header-carousel"
                        data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#header-carousel"
                        data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>
            </div>

            {/* -- Footer Start */}
            <div className="container-fluid bg-dark text-light footer3 pt-5 pb-5 wow fadeIn" data-wow-delay="0.1s">
                <div className="container py-5">
                    <div className="row g-5 foot">
                        <div className="col-lg-4 col-md-8">
                            <h4 className="text-light mb-4 foot-head"><span><u>Address</u></span></h4>
                            <p className="text-light mb-2">
                                <FontAwesomeIcon icon={faLocationDot} size="sm" className='me-3'/>
                                Kimathi street CBD, Nairobi, Kenya</p>
                            <p className="text-light mb-2 foot-con">
                                <FontAwesomeIcon icon={faPhone} size="4x" className='me-3'/>
                                +254 700112233</p>
                            <p className="text-light mb-2 foot-con">
                                <FontAwesomeIcon icon={faEnvelope} size="4x" className='me-3'/>
                                smartcars@gmail.com</p>
                            <div className="d-flex pt-2 foot-con">
                                <a className="btn btn-outline-light btn-social" href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon="fa-brands fa-facebook" size="6x" />
                                </a>
                                <a className="btn btn-outline-light btn-social" href="https://twitter.com/" target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon="fa-brands fa-twitter" size="6x"/>
                                </a>
                                <a className="btn btn-outline-light btn-social" href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon="fa-brands fa-linkedin" size="6x" />
                                </a>
                                <a className="btn btn-outline-light btn-social" href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon="fa-brands fa-instagram" size="6x"/>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-8">
                            <h4 className="text-light mb-4 foot-head">
                                <span>
                                    <FontAwesomeIcon icon={faClock} size="sm" className='me-2'/>
                                    <u>Opening Hours</u>
                                </span>
                            </h4>
                            <p className='text-light time'>Mon - Fri: 08:00 AM - 9:00 PM</p>
                            <p className='text-light time'>Sat: 09:00 AM - 1:00 PM</p>
                            <p className='text-light time'>Sunday - Closed</p>
                            
                        </div>
                        <div className="col-lg-4 col-md-8">
                            <h4 className="text-light mb-4 foot-head"><span><u>Services</u></span></h4>
                            <a className="btn btn-link" href="">Airport Travels</a>
                            <a className="btn btn-link" href="">Wedding Transport Services</a>
                            <a className="btn btn-link" href="">Private Travel services</a>
                            <a className="btn btn-link" href="">City and Safari Tours</a>
                            <a className="btn btn-link" href="">Goods and Cargo Transfer</a>
                        </div>

                    </div>
                </div>

                {/* <hr /> */}
                {/* Copyright */}
                <div className="copyright2">
                    <div style={{justify:'center'}}>
                        <div className="row">
                            <div className="col-lg-12">
                                <p className="p-small">Copyright. <a style={{color: 'orangered'}} href="/">SmartCars</a> &copy;2022 - {currentYear}.</p>
                                <p className="p-small">Designed and Developed By <a style={{color: 'orangered'}} href="https://otien0.vercel.app" target="_blank" rel="noopener noreferrer"><strong>Otien0</strong></a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Landing;